<template>
  <header class="o-the-header">
    <div class="o-the-header-navigation">
      <MoleculeTheHeaderLogo/>
      <MoleculeTheHeaderSubMenu/>
    </div>
  </header>
</template>

<script>
export default {
  name: 'OrganismTheHeader',

  components: {
    MoleculeTheHeaderLogo: () => import('@/components/molecules/MoleculeTheHeaderLogo'),
    MoleculeTheHeaderSubMenu: () => import('@/components/molecules/MoleculeTheHeaderSubMenu')
  }
}
</script>
